{
  "LABEL_MGMT": {
    "HEADER": "Oznake",
    "HEADER_BTN_TXT": "Dodaj oznaku",
    "LOADING": "Preuzimanje oznaka",
    "DESCRIPTION": "Labels help you categorize and prioritize conversations and leads. You can assign a label to a conversation or contact using the side panel.",
    "LEARN_MORE": "Learn more about labels",
    "SEARCH_404": "Nema razultata",
    "LIST": {
      "404": "Ne postoje dostupne oznake u ovom nalogu.",
      "TITLE": "Upravljanje oznakama",
      "DESC": "Oznake vam omogućavaju da grupišete razgovore.",
      "TABLE_HEADER": {
        "NAME": "Ime",
        "DESCRIPTION": "Opis",
        "COLOR": "Bojan"
      }
    },
    "FORM": {
      "NAME": {
        "LABEL": "Naziv oznake",
        "PLACEHOLDER": "Naziv oznake",
        "REQUIRED_ERROR": "Naziv oznake je obavezno",
        "MINIMUM_LENGTH_ERROR": "Obavezna je minimalna dužina od 2 karaktera",
        "VALID_ERROR": "Dozvoljena su samo slova, brojevi, crtice i donje crtice"
      },
      "DESCRIPTION": {
        "LABEL": "Opis",
        "PLACEHOLDER": "Opis oznake"
      },
      "COLOR": {
        "LABEL": "Bojan"
      },
      "SHOW_ON_SIDEBAR": {
        "LABEL": "Prikaži oznaku u traci sa strane"
      },
      "EDIT": "Uredi",
      "CREATE": "Napravi",
      "DELETE": "Izbriši",
      "CANCEL": "Otkaži"
    },
    "SUGGESTIONS": {
      "TOOLTIP": {
        "SINGLE_SUGGESTION": "Add label to conversation",
        "MULTIPLE_SUGGESTION": "Select this label",
        "DESELECT": "Deselect label",
        "DISMISS": "Dismiss suggestion"
      },
      "POWERED_BY": "AI",
      "DISMISS": "Dismiss",
      "ADD_SELECTED_LABELS": "Add selected labels",
      "ADD_SELECTED_LABEL": "Add selected label",
      "ADD_ALL_LABELS": "Add all labels",
      "SUGGESTED_LABELS": "Suggested labels"
    },
    "ADD": {
      "TITLE": "Dodaj oznaku",
      "DESC": "Oznake vam omogućavaju da grupišete razgovore.",
      "API": {
        "SUCCESS_MESSAGE": "Oznaka je uspešno dodata",
        "ERROR_MESSAGE": "Pojavila se greška, molim vas pokušajte ponovo"
      }
    },
    "EDIT": {
      "TITLE": "Uredi oznaku",
      "API": {
        "SUCCESS_MESSAGE": "Oznaka je uspešno izmenjena",
        "ERROR_MESSAGE": "Pojavila se greška, molim vas pokušajte ponovo"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Izbriši",
      "API": {
        "SUCCESS_MESSAGE": "Oznaka je uspešno obrisana",
        "ERROR_MESSAGE": "Pojavila se greška, molim vas pokušajte ponovo",
        "IN_USE_ERROR": "Ova oznaka ne može da se obriše jer se koristi u: {usages}. Prvo je uklonite iz tih stavki.",
        "IN_USE_FILTERS": "filteri: {names}",
        "IN_USE_AUTOMATIONS": "pravila automatizacije: {names}",
        "IN_USE_MACROS": "makroi: {names}"
      },
      "CONFIRM": {
        "TITLE": "Potvrdite brisanje",
        "MESSAGE": "Sigurni ste da želite izbrisati ",
        "YES": "Da, izbriši ",
        "NO": "Ne, zadrži "
      }
    }
  }
}
